import quickFetch from 'quick-fetch';
export const makeGroupsWithPropertiesQuickFetchKey = ({
  portalId = quickFetch.getPortalId(),
  frameworkTypeIdentifier,
  query
}) => `frameworkDataSchemaResolvers-${portalId}-properties-${frameworkTypeIdentifier}-${(query === null || query === void 0 ? void 0 : query.showHighlySensitiveProperties) || false}`;
export const getGroupsWithPropertiesFetchUrl = ({
  frameworkTypeIdentifier,
  query
}) => `/properties/v4/groups/${encodeURIComponent(frameworkTypeIdentifier)}/properties?includeFieldLevelPermission=true${query !== null && query !== void 0 && query.showHighlySensitiveProperties ? '&showHighlySensitiveProperties=true' : ''}`;
export const makeFrameworkTypesQuickFetchKey = ({
  portalId = quickFetch.getPortalId(),
  family
}) => `frameworkDataSchemaResolvers-${portalId}-frameworkTypes-${family}`;
export const makeFrameworkTypesFetchUrl = ({
  family
}) => family === 'objects' ? '/customer-object-types/v1/for-portal' : '/inbounddb-meta/v1/object-types/events/for-portal';
export const makePropertyMetadataEntriesFetchKey = ({
  frameworkTypeIdentifier,
  appSettingName,
  portalId = quickFetch.getPortalId()
}) => `frameworkDataSchemaResolvers-${portalId}-propertyMetadataEntries-${frameworkTypeIdentifier}-${appSettingName}`;
export const makePropertyMetadataEntriesFetchUrl = ({
  frameworkTypeIdentifier,
  appSettingName
}) => `/framework-builder/v1/read/metadata/property/${encodeURIComponent(frameworkTypeIdentifier)}/${encodeURIComponent(appSettingName)}`;
export const makePipelinesFetchKey = ({
  frameworkTypeIdentifier,
  portalId = quickFetch.getPortalId()
}) => `frameworkDataSchemaResolvers-${portalId}-pipelines-${frameworkTypeIdentifier}`;
export const makePipelinesFetchUrl = ({
  frameworkTypeIdentifier
}) => `/pipelines/v2/pipelines/${encodeURIComponent(frameworkTypeIdentifier)}?includeApprovalStageStatus=true&includePermissions=true`;
export const makeAssociationDefinitionsFetchKey = ({
  frameworkTypeIdentifier
}) => `associationDefinitions-${frameworkTypeIdentifier}`;
export const makeTypeMetadataEntriesFetchKey = ({
  portalId = quickFetch.getPortalId(),
  appSettingNames
}) => `frameworkDataSchemaResolvers-${portalId}-typeMetadataEntries-${appSettingNames.slice().sort().join(',')}`;
export const makeTypeMetadataEntryFetchKey = ({
  portalId,
  appSettingName
}) => makeTypeMetadataEntriesFetchKey({
  portalId,
  appSettingNames: [appSettingName]
});
export const makeTypeMetadataEntriesFetchUrl = () => '/framework-builder/v1/read/metadata/type/all/batch';